import { render, staticRenderFns } from "./today-bookings.vue?vue&type=template&id=9131380c&scoped=true"
import script from "./today-bookings.vue?vue&type=script&lang=js"
export * from "./today-bookings.vue?vue&type=script&lang=js"
import style0 from "./today-bookings.vue?vue&type=style&index=0&id=9131380c&prod&scoped=true&lang=css"
import style1 from "./today-bookings.vue?vue&type=style&index=1&id=9131380c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9131380c",
  null
  
)

export default component.exports